<template>
  <a-card :bordered='false'>
    <!-- Drawer -->
    <a-drawer
      title='ProductManagement'
      :width='screenWidth'
      @close='onClose'
      :visible='visible'
    >
      <!-- Drawer contentborder -->
      <div
        :style="{
          padding:'10px',
          border: '1px solid #e9e9e9',
          background: '#fff',
        }">

        <div class='table-page-search-wrapper'>
          <a-form layout='inline' :form='form' @keyup.enter.native='searchQuery'>
            <a-row>
              <a-col :md='2' :sm='24'>
                <a-button style='margin-bottom: 10px' type='primary' @click='handleAdd()'>Add</a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div>
          <a-table
            ref='table'
            rowKey='id'
            size='middle'
            :columns='columns'
            :dataSource='dataSource'
            :pagination='ipagination'
            :loading='loading'
            bordered
            @change='handleTableChange'
          >
            <template slot='status' slot-scope='text'>
              <a-badge :status="text == 1 ? 'success' : 'default'" />
              <span>{{ USER_STATUS[text] }}</span>
            </template>
            <span slot='action' slot-scope='text, record'>
              <a @click='handleEdit(record)'>Edit</a>
            </span>
          </a-table>

          <a-modal
            title='AddProduct'
            width='600px'
            :visible="visibleAdd"
            okText='Confirm'
            cancel-text="Cancel"
            @ok="handleOk()"
            @cancel="handleCancel()"
          >
            <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-form-item label="Name">
                <a-input placeholder="Please enterProductName" v-decorator="['name', validatorRules.name]"/>
              </a-form-item>
              <a-form-item label="Tenant ID">
                <a-input placeholder="Please enterProduct Tenant ID" v-decorator="['appSsid', validatorRules.appSsid]"/>
              </a-form-item>
              <a-form-item label="logo">
                <a-input placeholder="Please enterProductlogo" v-decorator="['logo', validatorRules.logo]"/>
              </a-form-item>
              <a-form-item label="Term">
                <a-input :placeholder=this.curDurations v-decorator="['duration', validatorRules.duration]"/>
              </a-form-item>
              <a-form-item label="Package Name">
                <a-input placeholder="Please enterProduct Package Name" v-decorator="['appPkgName', validatorRules.appPkgName]"/>
              </a-form-item>
              <a-form-item label="MostBigAmount">
                <a-input placeholder="Please enterProductMostBigAmount" v-decorator="['maxAmount', validatorRules.maxAmount]"/>
              </a-form-item>
              <a-form-item label="MostSmallAmount">
                <a-input placeholder="Please enterProductMostSmallAmount" v-decorator="['minAmount', validatorRules.minAmount]"/>
              </a-form-item>
              <a-form-item label="Disbursement Increment Amount">
                <a-input placeholder="Please enterProduct Disbursement Increment Amount" v-decorator="['incrAmount', validatorRules.incrAmount]"/>
              </a-form-item>
              <a-form-item label="Extension Quota">
                <a-input placeholder="Please enterProduct Extension Quota" v-decorator="['incrQuota', validatorRules.incrQuota]"/>
              </a-form-item>
              <a-form-item label="Service Fee Rate">
                <a-input placeholder="Please enterProduct Service Fee Rate" v-decorator="['serviceFeeRate', validatorRules.serviceFeeRate]"/>
              </a-form-item>
              <a-form-item label="Extension Service Fee">
                <a-input placeholder="Please enterProduct Extension Service Fee" v-decorator="['diferFeeRate', validatorRules.diferFeeRate]"/>
              </a-form-item>
              <a-form-item label="Overdue Fee Rate">
                <a-input placeholder="Please enterProduct Overdue Fee Rate" v-decorator="['overdueRate', validatorRules.overdueRate]"/>
              </a-form-item>
              <a-form-item label="Daily Interest Rate">
                <a-input placeholder="Please enterProduct Daily Interest Rate" v-decorator="['dayInterestRate', validatorRules.dayInterestRate]"/>
              </a-form-item>
              <a-form-item label="Allow Extension Time">
                <a-radio-group v-model:value="allowDiferTime" v-decorator="['allowDiferTime', validatorRules.allowDiferTime]">
                  <a-radio value="0">No Restriction</a-radio>
                  <a-radio value="1">Extension Not Allowed </a-radio>
                  <a-radio value="2">Before Expiry Only</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="AllowedPre-repayment">
                <a-radio-group v-model:value="allowPrepay" v-decorator="['allowPrepay', validatorRules.allowPrepay]">
                  <a-radio value="0">Not Allowed</a-radio>
                  <a-radio value="1">Allowed</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="YesNoEnable">
                <a-switch v-model:checked="detailStatus" />
              </a-form-item>
            </a-form>
          </a-modal>
        </div>
      </div>
    </a-drawer>
    <app-modal ref="modalForm" @ok="modalFormOk"></app-modal>
    <app-list ref="appList" @ok="modalFormOk"></app-list>
  </a-card>
</template>

<script>
import pick from 'lodash/pick'
import { addAppSub, deleteApp, getAllSubAppById, getDurationsByAppParentId } from '@/webpublicapi/system'
import { filterObj } from '@/utils/util'
import AppModal from '@/views/webpublic/system/modules/AppModal'
import AppList from '@/views/webpublic/system/AppList'

export default {
  name: 'subAppList',
  components: { AppList, AppModal },
  data() {
    return {
      validatorRules: {
        name: { rules: [{ required: true, message: 'ProductNamecannot be empty!' }] },
        appSsid: { rules: [{ required: true, message: 'Tenant IDcannot be empty!' }] },
        logo: { rules: [{ required: true, message: 'logocannot be empty!' }] },
        duration: { rules: [{ required: true, message: 'Termcannot be empty!' }] },
        appPkgName: { rules: [{ required: true, message: 'Package Namecannot be empty!' }] },
        maxAmount: { rules: [{ required: true, message: 'MostBigAmountcannot be empty!' }] },
        minAmount: { rules: [{ required: true, message: 'MostSmallAmountcannot be empty!' }] },
        incrAmount: { rules: [{ required: true, message: 'Disbursement Increment Amountcannot be empty!' }] },
        incrQuota: { rules: [{ required: true, message: 'Extension Quotacannot be empty!' }] },
        allowDiferTime: { rules: [{ required: true, message: 'ExtensionTimecannot be empty!' }] },
        allowPrepay: { rules: [{ required: true, message: 'Pre-repaymentcannot be empty!' }] },
        serviceFeeRate: { rules: [{ required: true, message: 'Service Fee Ratecannot be empty!' }] },
        diferFeeRate: { rules: [{ required: true, message: 'Extension Service Feecannot be empty!' }] },
        overdueRate: { rules: [{ required: true, message: 'Overdue Fee Ratecannot be empty!' }] },
        dayInterestRate: { rules: [{ required: true, message: 'Daily Interest Ratecannot be empty!' }] },
      },
      curDurations: 'Product term under this application is',
      allowDiferTime: undefined,
      allowPrepay: undefined,
      detailStatus: undefined,
      curId: undefined,
      // Pagination params
      ipagination: {
        current: 1,
        pageSize: 30,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' Total ' + total + ' records'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      dataSource: [],
      loading: false,
      columns: [
        {
          title: 'ApplicationName',
          align: 'left',
          dataIndex: 'appName'
        },
        {
          title: 'Tenant ID',
          align: 'left',
          dataIndex: 'appSsid'
        },
        {
          title: 'Package Name',
          align: 'left',
          dataIndex: 'appPackageName'
        },
        {
          title: 'Action',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      queryParam: {
        appName: ''
      },
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      title: 'Action',
      visible: false,
      visibleAdd: false,
      screenWidth: 800,
      appId: '',
      status: '1',
      labelCol: {
        xs: { span: 5 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 12 }
      },
      form: this.$form.createForm(this),
      USER_STATUS: {
        1: 'Enable',
        2: 'Disable'
      }
    }
  },
  created() {
    // When page initializes,Set drawer width based on screen size
    this.resetScreenSize()
  },
  methods: {
    searchQuery() {
      this.loadData(1)
    },
    // Reset dictionary type search box content
    searchReset() {
      var that = this
      that.queryParam.usertName = ''
      that.queryParam.mobileNo = ''
      that.loadData(this.ipagination.current)
    },
    loadData(arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      getAllSubAppById(this.curId).then((res)=>{
        if (res != null) {
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    handleTableChange(pagination, filters, sorter) {
      // TODO Filter
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field
        this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      }
      this.ipagination = pagination
      this.loadData()
    },
    add(appId) {
      this.appId = appId
      this.edit({})
    },
    edit (record) {
      this.curId = record.id
      console.dir(record)
      if (record.id) {
        this.appId = record.id
      }
      this.queryParam = {}
      this.form.resetFields()
      this.queryParam.appId = this.appId
      this.visible = true
      this.model = Object.assign({}, record)
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'appName', 'appSsid', 'appPackageName'))
      })
      // When other modules call this module,Call this method to load dictionary data
      this.loadData()
    },

    getQueryParams() {
      var param = Object.assign({}, this.queryParam)
      param.pageNum = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      return filterObj(param)
    },

    // Add dictionary data
    handleAdd() {
      this.showModal(this.curId)
      this.$refs.modalForm.title = 'Add'
    },
    handleEdit(record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = 'Edit'
    },
    handleDelete(id) {
      deleteApp({ id }).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.loadData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    //Get product term list under this app
    getDurationsByAppParentId(parentId) {
      getDurationsByAppParentId(parentId).then(res => {
        this.curDurations += res.data.toString()
      })
    },

    //Show modal
    showModal(id) {
      this.parentId = id
      this.getDurationsByAppParentId(id)
      this.visibleAdd = true;
    },
    //Close modal
    handleCancel() {
      this.close()
    },
    // Confirm
    handleOk () {
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          values.parentId = this.parentId
          values.allowPrepay = this.allowPrepay
          values.allowDiferTime = this.allowDiferTime
          if (this.detailStatus) {
            values.detailStatus=1
          } else {
            values.detailStatus=0
          }
          const formData = Object.assign(this.model, values)
          addAppSub(formData).then(res => {
            if (res.code === 1000) {
              this.$message.success("AddProductSuccess")
              this.searchQuery()
              this.$emit('ok')
            } else if (res.code === -1008) {
              this.$message.error("This tenant ID already exists")
            } else {
              this.$message.warning("AddProductFailed")
            }
          }).finally(() => {
            this.confirmLoading = false
            this.close()
          })
          this.close()
        }
      })
    },
    close () {
      this.form.resetFields()
      this.parentId = undefined
      this.allowPrepay = undefined
      this.allowDiferTime = undefined
      this.detailStatus = undefined
      this.curDurations = 'Product term under this application is'
      this.visibleAdd = false
    },
    onClose() {
      this.curId = undefined
      this.visible = false
      this.form.resetFields()
      this.allowPrepay = undefined
      this.allowDiferTime = undefined
      this.detailStatus = undefined
      this.curDurations = 'Product term under this application is'
      this.dataSource = []
    },
    // Drawer width changes with screen size
    resetScreenSize() {
      const screenWidth = document.body.clientWidth
      if (screenWidth < 800) {
        this.screenWidth = screenWidth
      } else {
        this.screenWidth = 800
      }
    },
    // modelCallback
    modalFormOk() {
      this.loadData()
    }
  }
}
</script>
<style scoped>

</style>
